import api from "./axios"
import { ENDPOINT_DEV } from './configs';
export const getAllOrganizationsAPI = async (limit: number) => {
    return await api
        .get(ENDPOINT_DEV + 'organization' + (limit ? ("?limit=" + limit) : ''))
        .then((res) => {
            return res;
        });
};
